import { render, staticRenderFns } from "./ConfirmationDialogPermissions.vue?vue&type=template&id=4cbf3d8e"
import script from "./ConfirmationDialogPermissions.vue?vue&type=script&lang=js"
export * from "./ConfirmationDialogPermissions.vue?vue&type=script&lang=js"
import style0 from "./ConfirmationDialogPermissions.vue?vue&type=style&index=0&id=4cbf3d8e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports